export default __webpack_public_path__ + "static/media/DSC_7984.66622bc7.jpg";